import React from 'react';
import {
    McIcon,
    McTag
} from '@maersk-global/mds-react-wrapper/components-core';
import { useApplicationAccess } from '../../hooks/useApplicationAccess'; // Custom hook for RBAC

interface QueryListToolbarProps {
    selectedQueryId: string | null;
    queries: any[];
    canCreateVersions: boolean;
    canActivateQueries: boolean;
    onViewHistory: (query: any) => void;
    onToggleActivation: (query: any) => void;
    onCreateVersion: (query: any) => void;
    activationPending: boolean;
}

export const QueryListToolbar: React.FC<QueryListToolbarProps> = ({
    selectedQueryId,
    queries,
    canCreateVersions,
    canActivateQueries,
    onViewHistory,
    onToggleActivation,
    onCreateVersion,
    activationPending
}) => {
    const selectedQuery = selectedQueryId ? queries.find(q => q.queryId === selectedQueryId) : null;
    const { hasAccess } = useApplicationAccess();
    const hasEditAccess = selectedQuery ? hasAccess(selectedQuery.applicationId) : false;

    return (
        <div
            style={{
                paddingLeft: '24px',
                paddingRight: '0px',
                paddingTop: '12px',
                paddingBottom: '12px',
                backgroundColor: selectedQueryId ? 'var(--mds-color-primary-weak-decoration)' : 'white',
                borderBottom: '1px solid var(--mds-color-neutral-weak-decoration)',
                transition: 'background-color 0.2s',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '2px'
            }}
        >
            <div style={{ flex: '1 1 auto', display: 'flex', alignItems: 'center', gap: '16px' }}>
                {selectedQueryId ? (
                    <div>
                        <span className="mds-text--x-small-regular" style={{ color: 'var(--mds-color-neutral-weaker-text)', display: 'block', marginBottom: '4px', textTransform: 'uppercase' }}>
                            SELECTED QUERY
                        </span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span className="mds-text--medium-bold">
                                {selectedQuery?.name || selectedQueryId}
                            </span>
                            <McTag
                                label={selectedQuery?.currentVersion}
                                style={{ height: '20px' }}
                            />
                            {selectedQuery?.applicationId && (
                                <McTag label={selectedQuery.applicationId} appearance="neutral" style={{ height: '20px' }} />
                            )}
                            {!hasEditAccess && selectedQuery && (
                                <div style={{ display: 'flex', alignItems: 'center', color: 'var(--mds-text-color-secondary)', fontSize: '0.75rem', marginLeft: '8px' }}>
                                    <McIcon icon="lock" size="16" style={{ marginRight: '4px' }} />
                                    <span>Read Only</span>
                                </div>
                            )}
                        </div>
                    </div>
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', opacity: 0.7 }}>
                        <McIcon icon="star" size="20" style={{ color: 'var(--mds-color-neutral-weaker-text)' }} />
                        <span className="mds-text--small-regular" style={{ color: 'var(--mds-color-neutral-weaker-text)' }}>
                            Select a query from the list below to perform actions
                        </span>
                    </div>
                )}
            </div>


        </div>
    );
};
